import {TranslateLoader} from "@ngx-translate/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import * as env from "../../../environments/environment";

const environment = (env as any).environment || env;

export class ElisTranslatorLoaderFactory{
    static forModule(): any {

        return class ProfileModuleTranslateLoader implements TranslateLoader {
            constructor(private httpClient: HttpClient) {}
            getTranslation(lang: string): Observable<any> {
                console.log(`loading translations with lang : ${lang}`);
                return this.httpClient.get(`${environment.elisTranslatorUrl}/${lang}/source.json`);
            }
        };
    }
}